import $ from 'jquery';

// import Swiper JS
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

(() => {

    $('.swiper__container').each( function() {

        let $swiper = $(this).find(">.swiper--slider");

        let args = {
            modules: [ Navigation ],
            init: false,
            autoHeight: true
        };
        
        /**
         * Navigation
         */ 
        
        if( $("> .swiper-button-next", $(this)).length > 0 ) {
            args.navigation = {
                nextEl: $("> .swiper-button-next", $(this))[0],
                prevEl: $("> .swiper-button-prev", $(this))[0]
            }
        }

        const swiper = new Swiper( $swiper[0], args );


        /**
         * Tabs
         */
        const $navItems = $(this).closest(".wp-block-adwerba-slider").find('> nav ul li');

        if( $navItems.length > 0 ) {

            // Zu Beginn und wenn ein Slide gewechselt wird, active-Klassen in der Navigation setzen
            swiper.on('init slideChange', function () {
                $navItems.removeClass('active');
                $( $navItems[ swiper.activeIndex ] ).addClass('active');
            } );
    
            // Beim Klicken der Navigation Slide wechseln
            $navItems.on('click', function() {
                swiper.slideTo( $navItems.index(this) ) 
            });

        }

        swiper.init();

    });

})();